import { Alert, Stack } from '@mui/material';
import { AccessRequestClientModel } from '@apono/client-app-sdk';

import { ErrorAlert } from '@common/ui/ErrorAlert';
import { Loader } from '@common/ui/Loader';

import AccessGroups from '@MyRequests/organisms/AccessGroups';
import TaskOverview from '@MyTasks/components/TaskOverview';

export default function TaskContent({
  isFetched,
  error,
  data,
}: {
  isFetched: boolean;
  error: unknown;
  data?: AccessRequestClientModel;
}) {
  if (!isFetched) {
    return <Loader />;
  }

  if (error) {
    return <ErrorAlert error={error} />;
  }

  if (!data) {
    return <Alert severity="error">Request not found</Alert>;
  }

  return (
    <Stack spacing={3}>
      <TaskOverview request={data} />
      <AccessGroups groups={data.access_groups} canSeeDetails={false} />
    </Stack>
  );
}
